import { ContactTextTypeModel } from 'ApiClient/metadata'

import { servicesAsync } from 'Common/environment/environment'
import { fetchGet } from 'Common/utils/query/request'

const contactTextTypesUrl = servicesAsync.contact('/v2/textTypes')

export const contactTextTypesGet = async () => {
    const result = await fetchGet(await contactTextTypesUrl)
    return (result ?? []) as ContactTextTypeModel[]
}
